import Nav from './components/Nav';
import Hero from './components/Hero';
import Mission from './components/Mission';
import Focus from './components/Focus';
import Recognition from './components/Recognition';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Nav />
      <Hero />
      <Mission />
      <Focus />
      <Recognition />
      <Footer />
    </>
  );
}
